import { render } from "./HeaderLogo.vue?vue&type=template&id=343ad768"
const script = {}

import exportComponent from "/usr/app/saas-stack/customer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__